module.exports = "<p>\n  medicallicensereportbystate works!\n</p>\n"